/**
 * Global top-of-viewport loading indicator.
 *
 * Subscribes to the axios inflight counter exposed by `lib/api.ts`. When >= 1
 * request is in flight, it animates a thin 2px bar across the top edge.
 * Keeps things simple: no external library.
 */

import { useEffect, useState } from 'react';

import { onRequestProgress } from '@/lib/api';
import { cn } from '@/lib/utils';

export function GlobalProgressBar() {
  const [pending, setPending] = useState(0);

  useEffect(() => onRequestProgress(setPending), []);

  const active = pending > 0;

  return (
    <div
      aria-hidden
      className={cn(
        'pointer-events-none fixed inset-x-0 top-0 z-[100] h-0.5 overflow-hidden',
        active ? 'opacity-100' : 'opacity-0 transition-opacity duration-300',
      )}
    >
      <div
        className={cn(
          'h-full w-1/3 bg-primary',
          active && 'animate-[progressbar_1s_linear_infinite]',
        )}
        style={{
          animationName: active ? 'sales-progress' : undefined,
          animationDuration: '1.2s',
          animationTimingFunction: 'linear',
          animationIterationCount: 'infinite',
        }}
      />
      <style>{`
        @keyframes sales-progress {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(150%); }
          100% { transform: translateX(400%); }
        }
      `}</style>
    </div>
  );
}
